/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Floor_Plan_2dInputs */

const cs_enum_floor_plan_2d = /** @type {(inputs: Enum_Floor_Plan_2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Půdorys 2D`)
};

const en_enum_floor_plan_2d = /** @type {(inputs: Enum_Floor_Plan_2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2D floor plan`)
};

/**
* | output |
* | --- |
* | "2D floor plan" |
*
* @param {Enum_Floor_Plan_2dInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_floor_plan_2d = /** @type {((inputs?: Enum_Floor_Plan_2dInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Floor_Plan_2dInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_floor_plan_2d(inputs)
	return cs_enum_floor_plan_2d(inputs)
});